const getObjectChips = (theme) => ({
	deal: {
		label: 'deal',
		borderColor: theme.palette.folioPurple,
		color: theme.palette.folioPurple,
		darkBorderColor: theme.palette.folioPurpleMid,
		darkColor: theme.palette.folioPurpleMid,
	},
	claim: {
		label: 'claim',
		borderColor: theme.palette.folioWarningMid,
		color: theme.palette.folioWarningMid,
		darkBorderColor: theme.palette.folioWarningMid,
		darkColor: theme.palette.folioWarningMid,
	},
	debtor: {
		label: 'debtor',
		borderColor: theme.palette.folioPurpleAccent,
		color: theme.palette.folioPurpleAccent,
		darkBorderColor: theme.palette.folioPurpleAccentMid,
		darkColor: theme.palette.folioPurpleAccentMid,
	},
	client: {
		label: 'client',
		borderColor: theme.palette.primary.main,
		color: theme.palette.primary.main,
		darkBorderColor: theme.palette.primary.main,
		darkColor: theme.palette.primary.main,
	},
	prospect: {
		label: 'prospect',
		borderColor: 'darkgray',
		color: 'darkgray',
		darkBorderColor: 'darkgray',
		darkColor: 'darkgray',
	},
	task: {
		label: 'task',
		borderColor: theme.palette.folioGreenDark,
		color: theme.palette.folioGreenDark,
		darkBorderColor: theme.palette.folioGreen,
		darkColor: theme.palette.folioGreen,
	},
	company: {
		label: 'company',
		borderColor: theme.palette.folioTealDark,
		color: theme.palette.folioTealDark,
		darkBorderColor: theme.palette.folioTealMid,
		darkColor: theme.palette.folioTealMid,
	},
});

const resolveChipColours = (chip, isDarkMode) =>
	isDarkMode
		? {
			...chip,
			borderColor: chip.darkBorderColor,
			color: chip.darkColor,
			backgroundColor: 'transparent',
		}
		: chip;

export const getDealChipProps = (pipeline, theme) => {
	const isDarkMode = theme.palette.mode === 'dark';
	const objectChips = getObjectChips(theme);
	if (pipeline === process.env.REACT_APP_PIPELINE_CLAIMS || pipeline === 'claim') {
		return resolveChipColours(objectChips.claim, isDarkMode);
	}
	if (pipeline === process.env.REACT_APP_PIPELINE_DEBTORS || pipeline === 'debtor') {
		return resolveChipColours(objectChips.debtor, isDarkMode);
	}
	return resolveChipColours(objectChips.deal, isDarkMode);
};

/**
 * Shared chip styles for object type labels
 */
export const getObjectChipProps = (objectType, { pipelineId, pipeline, isProspect, theme } = {}) => {
	const isDarkMode = theme.palette.mode === 'dark';
	const objectChips = getObjectChips(theme);
	const resolvedPipeline = pipeline ?? pipelineId;
	switch (objectType) {
	case 'clientCreated':
	case 'client':
		return resolveChipColours(
			isProspect ? objectChips.prospect : objectChips.client,
			isDarkMode,
		);
	case 'prospectCreated':
	case 'prospect':
		return resolveChipColours(objectChips.prospect, isDarkMode);
	case 'task':
	case 'taskAssigned':
		return resolveChipColours(objectChips.task, isDarkMode);
	case 'claim':
	case 'claimCreated':
	case 'claimCompleted':
		return resolveChipColours(objectChips.claim, isDarkMode);
	case 'debtor':
	case 'debtorCompleted':
		return resolveChipColours(objectChips.debtor, isDarkMode);
	case 'dealCreated':
	case 'dealCompleted':
	case 'deal':
		return getDealChipProps(resolvedPipeline, theme);
	case 'company':
		return resolveChipColours(objectChips.company, isDarkMode);
	default:
		return null;
	}
};
